module.exports = __webpack_public_path__ + "media/images/pen_sienna-d813f10c.png";